import React from "react";
import { observer } from "mobx-react";
import { TerritoryViewStore } from "../../store";
import { TerritoryViewForm } from "./TerritoryViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type TerritoryViewProps = {
  territoryViewStore: TerritoryViewStore;
};

export const TerritoryView: React.FC<TerritoryViewProps> = observer(
  ({ territoryViewStore }) => {
    return (
      <div>
        <TerritoryViewForm
          name_es={territoryViewStore.name_esValue}
          name_en={territoryViewStore.name_enValue}
          name_pt={territoryViewStore.name_ptValue}
          onPrint={(handlePrint: () => void) =>
            territoryViewStore.printTerritory(handlePrint)
          }
          onCancel={() => territoryViewStore.cancelTerritory()}
          onEdit={
            territoryViewStore.isEditEnabled
              ? () => territoryViewStore.editTerritory()
              : undefined
          }
        />
        <ErrorDialog
          open={territoryViewStore.errorDialogOpened}
          title={territoryViewStore.errorTitle}
          description={territoryViewStore.errorDescription}
          onClose={() => territoryViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
